<template>
  <div class="execution">
    <div class="container-router">
      <div class="title">
        <h1 class="medium-title">Orders</h1>
        <ul v-if="!user.admin" class="title__menu">
          <router-link tag="li" :to="{name: 'allorder'}">
            All Order <badge v-if="badgeAllOrder" class="badge" :number.sync="badgeAllOrder"/>
          </router-link>
          <router-link tag="li" :to="{name: 'orderactive'}">
            Active <badge v-if="bagdeRouter[1].number" class="badge" :number.sync="bagdeRouter[1].number"/>
          </router-link>
        </ul>
        <ul v-else class="title__menu">
          <router-link tag="li" :to="{name: 'allorder'}">
            All Order <badge v-if="badgeAllOrder" class="badge" :number.sync="badgeAllOrder"/>
          </router-link>
          <router-link tag="li" :to="{name: 'orderpayment'}">
            Payment
          </router-link> 
          <router-link tag="li" :to="{name: 'orderactive'}">
            Active <badge v-if="bagdeRouter[1].number" class="badge" :number.sync="bagdeRouter[1].number"/>
          </router-link>
          <router-link tag="li" :to="{name: 'ordercanceled'}">
            Canceled <badge v-if="bagdeRouter[2].number" class="badge" :number.sync="bagdeRouter[2].number"/>
          </router-link>
          <router-link tag="li" :to="{name: 'orderexpired'}">
            Expired
          </router-link>
          <router-link tag="li" :to="{name: 'orderdormant'}">
            Dormant
          </router-link>
        </ul>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'
import Badge from '@/components/Badge'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'adx-bus-execution',
  components: {
    'adx-loading': Loading,
    'adx-pagination': Pagination,
    'badge': Badge,
  },
  props: {

  },
  data() {
    return {
      items: [],
      isLoading: false,
      currentPage: 1,
      maxPage: 1,
      user: {
        admin : null
      },
      isAdmin: null,
      badgeAllOrder: null,
      bagdeRouter:[
        {
          value: 'orderpayment',
          number: null
        },
        {
          value: 'orderactive',
          number: null
        },
        {
          value: 'ordercanceled',
          number: null
        },
        {
          value: 'orderexpired',
          number: null
        },
        {
          value: 'orderdormant',
          number: null
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      account: 'account'
    })
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    const { page } = this.$route.query
    if(page){
      this.currentPage = parseInt(page)
    }
    this.initialLoad()
    this.user.admin = this.account.isStaff
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async changePage (selected) {
      history.pushState(null, null, '?page=' + selected);
      this.currentPage = selected
      await this.$apollo.queries.busNotificationsByOrder.refetch()
      
    },
    async initialLoad(){
      const result1 = await this.$apollo.query({
        query: require('@/graphql/bus/busNotificationsByOrder.gql'),
        variables: {
          campaignStatus: ""
        },
      });
      const result2 = await this.$apollo.query({
        query: require('@/graphql/bus/busNotificationsByOrder.gql'),
        variables: {
          campaignStatus: "2"
        },
      });
      const result3 = await this.$apollo.query({
        query: require('@/graphql/bus/busNotificationsByOrder.gql'),
        variables: {
          campaignStatus: "3"
        },
      });
      this.badgeAllOrder = result1.data.busNotificationsByOrder
      this.bagdeRouter[1].number = result2.data.busNotificationsByOrder
      this.bagdeRouter[2].number = result3.data.busNotificationsByOrder
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>